import { render, staticRenderFns } from "./friendsLinkDetail.vue?vue&type=template&id=3da0afc5&scoped=true"
import script from "./friendsLinkDetail.vue?vue&type=script&lang=js"
export * from "./friendsLinkDetail.vue?vue&type=script&lang=js"
import style0 from "./friendsLinkDetail.vue?vue&type=style&index=0&id=3da0afc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da0afc5",
  null
  
)

export default component.exports